/**
 * Фиксированная шапка сайта
 * Управляет переключением CSS-класса для переданного HTML элемента
 * при достижении заданного порогового значения при прокрутке страницы 
 */

class FixedHeader {

  /**
   * 
   * @param {Object} options 
   * @param {HTMLElement} options.element Фиксируемый элемент (шапка сайта, меню и т. п.)
   * @param {Number} options.threshold  Пороговое значение прокрутки для показа/сокрытия (обычно высота элемента)
   * @param {Number} options.classToToggle  Класс, который требуется переключать
   * 
   */
  constructor(options) {
      // https://stackoverflow.com/questions/40897551/my-scroll-handler-javascript-doesnt-work-in-internet-explorer/40897596
      // window.pageYOffset vs window.scrollY

      // console.log(options);
      
      window.addEventListener('scroll', function() {
        (window.pageYOffset > options.threshold) ? 
          options.element.classList.add(options.classToToggle):
          options.element.classList.remove(options.classToToggle);
      });
  }
}

export default FixedHeader;